<template>
  <div>
    <hr v-if="index !== 0" />
    <div class="common-flex common-justify-between pHeader">
      <div class="common-flex common-align-center">
        <img :src="items.imagePath" width="32" style="margin-right: 11px" />
        <span>{{ items.name }}</span>
      </div>
      <div
        class="common-flex common-align-center"
        style="flex: 0 0 782px"
        v-if="index === 0"
      >
        <Select
          v-model="params.productId"
          placeholder=" "
          size="large"
          style="flex: 0 0 175px; margin-right: 15px"
          @on-change="handleSource"
        >
          <Option
            v-for="item in productList"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <!-- {{params.productId}} -->

        <div
          v-if="params.productId === 'sys'"
          class="common-flex common-align-center fabricSearch"
          style=" margin-right: 15px"
        >
          <AutoComplete
            ref="fabricRef"
            class="borderRightLess faricChoose"
            v-model="submitData.fabric"
            clearable
            placeholder="Fabric #"
            @on-change="handleRemoteFabric"
            @on-blur="handleFabricBlur"
            @on-select="handleFabricChange"
            @on-clear="handleFabricClear"
            @keydown.enter.native.prevent="onFabricEnter"
            style="height: 40px"
          >
            <Option
              v-for="(item, index) in fabricList"
              :key="index"
              :value="item.fabricCode"
              >{{ item.fabricCode }}</Option
            >
          </AutoComplete>

          <Badge
            v-if="fabricStock || fabricStock === 0"
            :status="fabricStock > 0 ? 'success' : 'error'"
            :text="fabricStock"
            style="flex: 1 1 50%; text-align: right"
          >
          </Badge>
        </div>
        <Input
          class="cmtInput"
          v-else
          v-model="submitData.fabric"
          placeholder="Fabric #"
          style=" margin-right: 15px;width:283px"
        >
        </Input>
        <Input
          class="cmtInput"
          v-model="submitData.amount"
          placeholder="Amount #"
          style="flex: 0 0 50px; margin-right: 15px"
        >
        </Input>
        <Input
          v-model="submitData.cusOrderCode"
          size="large"
          placeholder="Order#"
          style="flex: 0 0 130px; margin-right: 15px"
        />
        <Button @click.native="handleFabricDel">
          <Icon custom="iconfont iconqingkong" color="red"></Icon>
        </Button>
      </div>
    </div>
    <div class="r-peofessional">
      <div class="title">{{ $t("peofessional.crafts") }}</div>
      <div
        class="common-flex common-space-between relative"
        style="margin-bottom: 20px"
      >
        <div class="relative gy" style="flex: 0 0 1082px">
          <AutoComplete
            class="craftAutocomplete"
            ref="autocomplete"
            v-model="items.craftVal"
            clearable
            icon="ios-search"
            :placeholder="$t('peofessionalOrder.enterCrafts')"
            style="width: 468px"
            @on-select="changeCrafts"
            @on-focus="handleFocus"
            @on-change="handleChange"
            @keydown.enter.native.prevent="enterEvent(items)"
          >
            <Option
              v-for="item in items.CraftsList"
              :value="item.ecode"
              :key="item.id"
              @mouseenter.native="handleEnter(item)"
              @mouseleave.native="handleLeave(item)"
            >
              <div
                class="common-flex"
                style="border-bottom: 1px solid #f7f7f7; padding: 10px 0"
              >
                <div>【</div>
                <div>{{ item.ecode }}</div>
                <div>】</div>
                <div>{{ item.name }}</div>
              </div>
            </Option>
          </AutoComplete>
          <div class="absolute craftImg" v-if="craftImg">
            <img
              :src="craftImg"
              width="420"
              :alt="$t('peofessional.craftImg')"
              @error="handleError"
            />
          </div>
          <div
            v-show="items.craftList.length > 0"
            style="margin-top: 15px; width: 1200px; margin-right: 20px"
          >
            <Tooltip v-for="(item, index) in items.craftList" :key="item.ecode" :content="item.ecode" placement="right">
            <div
              :style="[
                index % 2 == 0
                  ? { background: '#F8F8F8' }
                  : { background: '#fff' }
              ]"
              :key="item.id"
              class="crafts-chosoe-item common-flex"
            >
              <div
                class="common-flex common-align-center"
                style="cursor: pointer; max-width: 60%"
                @click="handleCraftClick(item)"
              >
                <div class="line"></div>
                <div class="crafts-item-name">{{ item.ecode }}</div>
                <div
                  class="crafts-item-content"
                  :title="item.parentName + ':' + item.name"
                >
                  {{ item.parentName }}:{{ item.name }}
                </div>
              </div>
              <Input
                v-if="item.sourceType === 'TEXT'||item.sourceType === 'STYLE'"
                readonly
                v-model="item.content"
                size="small"
                style="margin-left: 5px; width: 180px"
                @click.native="handleCraftContent(item, 'TEXT')"
              ></Input>
              <Button
                v-if="item.sourceType === 'FILE'"
                icon="ios-cloud-upload-outline"
                style="margin-left: 5px"
                @click.native="handleCraftContent(item, 'FILE')"
              >
                {{
                  item.fileName ? item.fileName : $t("peofessional.uploadName")
                }}</Button
              >
              <span v-if="item.price" class="craftPrice"
                >+{{ item.price }}</span
              >
              <span @click="clearCraft(index)" class="iconfont iconguanbi common-hover"/>
            </div>
            </Tooltip>
          </div>
        </div>
        <div class="absolute craftClickImg" v-if="items.craftSelected">
          <img
            class="product-img"
            :src="items.craftSelected.craftPath"
            alt=""
            width="180"
          />
        </div>
      </div>
      <div class="title">{{ $t("peofessional.monogram") }}</div>
      <div
        class="common-flex cx"
        style="margin-bottom: 20px"
        v-for="(embItem, embIndex) in items.embList"
        :key="'e_' + embIndex"
      >
        <Select
          v-model="embItem.site"
          filterable
          :placeholder="$t('peofessionalOrder.monogram.position')"
          style="width: 224px; margin-right: 20px"
          @on-change="handlePostionChange"
        >
          <Option
            v-for="item in embsPosition.children"
            :value="item.id"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          v-model="embItem.color"
          filterable
          :placeholder="$t('peofessionalOrder.monogram.threadNumber')"
          style="width: 224px; margin-right: 20px"
        >
          <Option
            v-for="(item, cIndex) in embsColor.children"
            :value="item.id"
            :key="cIndex"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          v-model="embItem.font"
          filterable
          :placeholder="$t('peofessionalOrder.monogram.font')"
          style="width: 224px; margin-right: 20px"
          @on-change="
            val => {
              handleFontChange(val, embItem);
            }
          "
        >
          <Option
            v-for="item in embsFont.children"
            :value="item.id"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
        <Select
          v-if="items.id === 3000 || items.id === 5000 || items.id === 11000"
          v-model="embItem.embSize"
          filterable
          placeholder="size"
          style="width: 224px; margin-right: 20px"
        >
          <Option
            v-for="item in embsSize.children"
            :value="item.id"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
        <template v-if="embItem.uploadContent">
          <Button
            v-if="embItem.file"
            class="embsUploadBtn embsUploadBtn2"
            style="width: 224px"
          >
            <a :href="embItem.href" download="" :title="embItem.fileName" style="overflow: hidden;width: 200px">{{ embItem.fileName }}</a>
            <Icon
              type="ios-close"
              :size="24"
              @click="handleUploadClose(embItem)"
            />
          </Button>
          <Upload
            v-else
            :action="baseUrl + 'pc/attachment/upload'"
            :headers="uploadHeaders"
            :data="uploadData"
            :show-upload-list="false"
            accpet="image/*"
            :format="['png', 'jpg', 'jpeg']"
            :max-size="2048"
            :on-success="
              (response, file, fileList) => {
                handleUploadSuccess(response, file, fileList, embItem);
              }
            "
            :on-error="handleEmbUploadError"
          >
            <Button
              class="embsUploadBtn"
              icon="ios-cloud-upload-outline"
              style="width: 224px"
            >
              {{ $t("peofessional.uploadName") }}</Button
            >
          </Upload>
        </template>

        <Input
          v-else
          class="emb_content"
          v-model="embItem.embContent"
          :placeholder="$t('peofessionalOrder.monogram.content')"
          style="width: 224px"
        />
        <img
          v-if="embIndex == items.embList.length - 1"
          class="add-btn common-hover"
          @click="add"
          src="../assets/images/add.png"
          alt=""
        />
        <div
          v-else
          @click="clearMonogram(embIndex)"
          class="iconfont iconqingkong common-hover"
          style="
            width: 36px;
            height: 36px;
            text-align: center;
            line-height: 36px;
          "
        ></div>
      </div>
      <!-- <template
        v-if="items.contrastSaveList && items.contrastSaveList.legnth > 0"
      >
        <div class="title">Color contrast</div>
        <div
          class="common-flex common-align-center"
          style="margin-bottom: 20px"
          v-for="(item, index) in items.contrastSaveList"
          :key="'c_' + index"
        >
          <Select
            v-model="item.site"
            :placeholder="$t('peofessionalOrder.monogram.position')"
            style="width: 468px; margin-right: 20px"
          >
            <Option
              v-for="(item, pIndex) in colorContrastPosition.children"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <Select
            v-model="item.color"
            :placeholder="$t('peofessionalOrder.monogram.threadNumber')"
            style="width: 468px"
          >
            <Option
              v-for="(item, cIndex) in colorContrastFabric.children"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <img
            v-if="index == items.contrastSaveList.length - 1"
            class="add-btn common-hover"
            @click="addColorContrast"
            src="../assets/images/add.png"
            alt=""
          />
          <div
            v-else
            @click="clearColorContrast(index)"
            class="iconfont iconqingkong common-hover"
          ></div>
        </div>
      </template> -->
    </div>
    <Modal
      v-model="craftContentShow"
      width="300"
      :styles="{ top: '300px' }"
      :ok-text="$t('peofessional.ok')"
      :cancel-text="$t('peofessional.cancel')"
      @on-cancel="handleCraftContentCancel"
    >
      <template v-slot:header>
        <div class="craftContentTitle">
          {{
            craftContentTitle
              ? craftContentTitle
              : $t("peofessional.uploadName")
          }}
        </div>
      </template>
      <Input
        v-if="uploadType === 'TEXT'"
        ref="customText"
        v-model="craftContent"
        autofocus
        @keydown.enter.native.prevent="handleCraftContentOk"
      ></Input>
      <AutoComplete
        v-if="uploadType === 'STYLE'"
        ref="styleText"
        v-model="craftContent"
        autofocus
        clearable
        icon="ios-search"
        placeholder="please enter the code"
        style="width: 260px;"
        @on-select="changeStyleNo"
        @on-focus="handleFocus"
        @on-change="handleChangeStyle"
        @keydown.enter.native.prevent="handleStyleContentOk(items)"
      ><Option
          v-for="item in items.CraftsList"
          :value="item.ecode"
          :key="item.id"
          @mouseenter.native="handleEnter(item)"
          @mouseleave.native="handleLeave(item)"
        >
          <div
            class="common-flex"
            style="border-bottom: 1px solid #f7f7f7; padding: 10px 0"
          >
            <div>【</div>
            <div>{{ item.ecode }}</div>
            <div>】</div>
            <div>{{ item.name }}</div>
          </div>
        </Option>
      </AutoComplete>
      <template v-else-if="uploadType === 'FILE'">
        <div class="upload-list" v-if="craftUpload.href">
          <img :src="craftUpload.href" />
          <div class="upload-list-cover">
            <Icon type="ios-eye-outline" @click.native="handleView()"></Icon>
            <Icon
              type="ios-trash-outline"
              @click.native="handleRemove()"
            ></Icon>
          </div>
        </div>
        <Upload
          ref="upload"
          type="drag"
          :show-upload-list="false"
          :on-success="handleCraftUploadSuccess"
          :format="['jpg', 'jpeg', 'png']"
          :max-size="2048"
          :action="baseUrl + 'pc/attachment/upload'"
          :headers="uploadHeaders"
          style="display: inline-block; width: 58px"
        >
          <div style="width: 58px; height: 58px; line-height: 58px">
            <Icon type="ios-camera" size="20"></Icon>
          </div>
        </Upload>
        <Modal title="view pictures" v-model="craftUploadVisible">
          <img
            :src="craftUploadSrc"
            v-if="craftUploadVisible"
            style="width: 100%"
          />
        </Modal>
      </template>
      <template v-slot:footer>
        <Button small @click="handleCraftContentCancel">{{
          $t("peofessional.cancel")
        }}</Button>
        <Button v-if="craftContentTitle!=='style number'" type="primary" small @click="handleCraftContentOk">{{
          $t("peofessional.ok")
        }}</Button>
        <Button v-if="uploadType === 'TEXT'&&craftContentTitle==='style number'" type="primary" small @click="handleStyleContentOk(items)">{{
            $t("peofessional.ok")
          }}</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import { getArchivesData, getCraftPrice,getStyleData,getStyleInfoData } from "@/api/peofessional";
import RAutocomplete from "./r-autocomplete.vue";
import { getToken, getBrowserLang } from "@/libs/util.js";
import { baseUrl } from "@/libs/config";
export default {
  name: "rPeofessional",
  props: {
    items: Object,
    submitData: Object,
    index: Number,
    params: Object,
    productList: Array,
    fabricList: Array,
    categoryList: Array,
    fabricStock: Number | String
  },
  data() {
    return {
      craftContentTitle: "",
      craftContentShow: false,
      craftContent: "",
      currentItem: {},
      craftImg: "",
      value: "",
      colorContrast: [{}],
      chooseCrafts: [],
      loading: false,
      embsFont: {},
      embsColor: {},
      embsSize: {},
      embsPosition: {},
      colorContrastFabric: {},
      colorContrastPosition: {},
      embItem: {
        // 刺绣
        site: null, // 位置
        color: null, // 颜色
        font: null, // 字体
        embSize: null, // 绣字大小
        embContent: "", // 内容
        file: null, // 附件id
        fileName: "",
        uploadContent: false
      },
      craftItem: {
        // 工艺信息
        craftId: null,
        file: null,
        content: ""
      },
      contrastItem: {
        // 撞色
        site: null, // 位置
        color: null // 颜色
      },
      uploadHeaders: {
        authorization: getToken(),
        "Accept-Language": getBrowserLang() == "zh" ? "zh" : "en"
      },
      uploadData: {},
      craftUploadShow: false,
      baseUrl: baseUrl,
      craftUpload: {
        file: null,
        fuileName: "",
        href: ""
      },
      uploadType: "",
      craftUploadVisible: false,
      craftUploadSrc: "",
      selectFabric:''
    };
  },
  watch: {
    items: {
      handler: function(newVal) {
        this.$emit("update:items", newVal);
        if (this.items.id === 5000) {
          if (this.items.craftList.length > 0) {
            let pjId =
              this.items.craftList[0].id || this.items.craftList[0].craftId;
            this.getEmbInfo(2, pjId);
          }
        }
      },
      deep: true,
      immediate: true
    },
    submitData: {
      handler: function(newVal) {
        this.$emit("update:submitData", newVal);
      },
      deep: true,
      immediate: true
    },
    params: {
      handler: function(newVal) {
        this.$emit("update:params", newVal);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    setSelectFabric(e){
      this.selectFabric = e
    },
    // 新增
    add() {
      this.items.embList.push(JSON.parse(JSON.stringify(this.embItem)));
    },
    addColorContrast() {
      this.items.contrastSaveList.unshift(
        JSON.parse(JSON.stringify(this.contrastItem))
      );
    },
    clearColorContrast(e) {
      this.items.contrastSaveList.splice(e, 1);
    },
    //款式号
    async handleChangeStyle(keyword) {
      if (keyword.length < 4) return false;
      try {
        this.loading = true;
        let response = await getStyleData({
          pid: this.currentItem.id,
          keyword: keyword,
        });
        let { data, code } = response;
        this.$set(this.items, "CraftsList", data.data);
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    handleChange(val) {
      if (!val) {
        this.handleFocus();
        return false;
      }
      this.remote(val);
    },
    // 当前品类为配件时，判断第一个选中的工艺是否为系列
    handleJudgeSeries() {
      let firstCategory = this.categoryList.find(item => {
        return item.id === this.items.id;
      });
      if (
        firstCategory &&
        firstCategory.craftList &&
        firstCategory.craftList.length > 0 &&
        firstCategory.craftList[0].parentId === 5023
      ) {
        return firstCategory.craftList[0].id;
      } else {
        return false;
      }
    },
    // 搜索输入
    async remote(query) {
      if (query.length < 2) return false;
      if (query) {
        let pjId = null;
        if (this.items.id === 5000) {
          pjId = this.handleJudgeSeries();
        }
        try {
          this.loading = true;
          let response = await getArchivesData({
            type: 1,
            craftCode: query,
            category: this.items.id,
            pjId: pjId || ""
          });
          let { data, code } = response;
          this.$set(this.items, "CraftsList", data.data);
          this.loading = false;
          // if(data.data.length<=1) return false
          // if(query.length<4) return false
          // this.$nextTick(() => {
          //     const selectDom = document.querySelector(
          //       ".craftAutocomplete .ivu-select-dropdown-list .ivu-select-item-focus"
          //     );

          //     if(!selectDom) return false
          //     const selectContainer = document.querySelector('.craftAutocomplete .ivu-select-dropdown')
          //     const selectContainerHeight = selectContainer.offsetHeight
          //     const selectList = document.querySelector(
          //       ".craftAutocomplete .ivu-select-dropdown-list")
          //     const selectListHeight = selectList.offsetHeight
          //     if(selectListHeight<=selectContainerHeight) return false
          //     const selectDomTop = selectDom.scrollTop
          //     selectContainerHeight.scrollTo({
          //       top:selectDomTop
          //     })
          // });
        } catch (error) {
          this.loading = false;
        }
      } else {
      }
    },
    handleFocus() {
      this.$set(this.items, "CraftsList", []);
    },
    //选中款式号
    async changeStyleNo(ecode) {
      this.$set(this.currentItem, "content", ecode);
      this.craftContent = "";
      this.craftContentShow = false;
      try {
        this.loading = true;
        let response = await getStyleInfoData(this.items.id, ecode);
        let { data, code } = response;
        this.$set(this.items, "CraftsList", data.data);
        data.data.forEach(c=>{
          if (this.items.craftList.length > 0) {
            if (c.chooseType === "RADIO") {
              let hasId = this.items.craftList.some(item => {
                return c.parentId === item.parentId;
              });
              if (hasId) {
                this.$Message.error("Multiple processes are not allowed under the same category.");
                return false;
              }
            }
          }
          this.items.craftList.push({
            ...c,
            craftId: c.id,
            file: null,
            fileName: "",
            href: "",
            content: c.remark
          });
        })
        this.handleCraftPrice();
        this.$refs.styleText.handleClear();
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    // 修改品类
    async changeCrafts(ecode) {
      if (!ecode) return false;
      this.craftImg = "";
      let craftItem = this.items.CraftsList.find(item => {
        return item.ecode === ecode;
      });
      console.log( "craftItem",JSON.stringify(craftItem))
      if (this.items.id === 5000) {
        let parentId = craftItem.parentId;
        let pjId = this.handleJudgeSeries();
        if (!pjId && parentId !== 5023) {
          this.$Message.error("Please select the series first for the process of category Accessory");
          this.$refs.autocomplete.handleClear();
          return false;
        }
        if (parentId === 5023) {
          this.getEmbInfo(2, craftItem.id);
        }
      }
      if (this.items.craftList.length > 0) {
        if (craftItem.chooseType === "RADIO") {
          let hasId = this.items.craftList.some(item => {
            return craftItem.parentId === item.parentId;
          });
          if (hasId) {
            this.$Message.error("Multiple processes are not allowed under the same category.");
            this.$refs.autocomplete.handleClear();
            return false;
          }
        }
      }
      this.items.craftList.push({
        ...craftItem,
        craftId: craftItem.id,
        file: null,
        fileName: "",
        href: "",
        content: ""
      });
      this.handleCraftPrice();
      this.$refs.autocomplete.handleClear();
      if (craftItem.sourceType === "TEXT"||craftItem.sourceType === "STYLE") {
        let currentItem = this.items.craftList[this.items.craftList.length - 1];
        this.craftContentTitle = currentItem.name;
        this.handleCraftContent(currentItem, "TEXT");
      }
      this.$emit("reviseSzieList", craftItem);
    },
    // 工艺价格
    async handleCraftPrice() {
      let craftPrice = await this.getSelectedCraftPrice();
      craftPrice.map(cp => {
        this.categoryList.map(citem => {
          citem.craftList.map(craftItem => {
            if (!cp.price) {
              if (cp.id === craftItem.craftId) {
                this.$set(craftItem, "price", undefined);
              }
            } else {
              if (cp.id === craftItem.craftId) {
                this.$set(craftItem, "price", cp.price);
              }
            }
          });
        });
      });
      this.$emit("update:categoryList", this.categoryList);
    },
    // 获取工艺价格
    getSelectedCraftPrice() {
      return new Promise(async (resolve, reject) => {
        try {
          let response = await getCraftPrice(this.getCraftChooseIds());

          resolve(response.data.data);
        } catch (error) {
          reject(error);
        }
      });
    },
    // 获取已经选择的工艺的id
    getCraftChooseIds() {
      let data = [];
      this.categoryList.map(citem => {
        data.push({
          category: citem.id,
          chooseIds: ""
        });
        citem.craftList.map(item => {
          data[data.length - 1].chooseIds += item.craftId + ",";
        });
      });
      return data;
    },
    // 删除品类
    clearCraft(e) {
      let parentId = null;
      if (this.items.id === 5000) {
        parentId = this.items.craftList[e].parentId;
      }
      if (this.items.craftSelected) {
        if (this.items.craftList[e].id === this.items.craftSelected.id) {
          this.$set(this.items, "craftSelected", null);
        }
      }
      this.items.craftList.splice(e, 1);
      if (parentId === 5023) {
        this.items.craftList = [];
        this.embsFont.children = [];
        this.embsColor.children = [];
        this.embsSize.children = [];
        this.embsPosition.children = [];
        this.items.embList.map(item => {
          item.embSize = null;
          item.site = null; // 位置
          item.color = null; // 颜色
          item.font = null; // 字体
          item.embContent = ""; // 内容
          item.file = null; // 附件id
          item.fileName = "";
        });
      }
      this.handleCraftPrice();
      let hasExtension = this.items.craftList.some(item => {
        return item.extension;
      });
      if (!hasExtension) {
        this.$emit("clearCraft");
      }
    },
    // 删除
    clearMonogram(e) {
      this.items.embList.splice(e, 1);
    },
    // 获取刺绣撞色信息
    async getEmbInfo(type, pjId) {
      try {
        let response = await getArchivesData({
          category: this.items.id,
          type,
          pjId
        });
        let { data, code } = response;
        if (type === 2) {
          this.handleEmbInfo(data.data);
        } else if (type === 3) {
          this.handleColorContrast(data.data);
        }
      } catch (error) {}
    },
    // 处理刺绣部位颜色字体
    handleEmbInfo(embData) {
      if (embData.length > 0) {
        this.embsFont = embData.find(item => {
          return item.extension === "emb_font";
        });
        this.embsSize = embData.find(item => {
          return item.extension === "emb_size";
        });
        this.embsColor = embData.find(item => {
          return item.extension === "emb_color";
        });
        this.embsPosition = embData.find(item => {
          return item.extension === "emb_position";
        });
      } else {
        this.embsFont.children = [];
        this.embsColor.children = [];
        this.embsSize.children = [];
        this.embsPosition.children = [];
      }
    },
    // 刺绣位置选择
    handlePostionChange(val) {
      let hasPositionIdItem = this.items.embList.filter(embItem => {
        return embItem.site === val;
      });
      let fitIndex = this.items.embList.findIndex(embItem => {
        return embItem.site === val;
      });
      let len = hasPositionIdItem.length;
      if (len > 1) {
        this.items.embList.map((embItem, embIndex) => {
          if (embItem.site === val && embIndex > fitIndex) {
            this.$set(embItem, "site", null);
          }
        });
        this.$Message.error("已存在此刺绣位置，请勿重复选择");
      }
    },
    // 处理撞色
    handleColorContrast(colorContrastData) {
      consolr.log(colorContrastData);
      this.colorContrastFabric = colorContrastData.find(item => {
        return item.extension === "contrast_fabric";
      });
      this.colorContrastPosition = colorContrastData.find(item => {
        return item.extension === "contrast_position";
      });
    },
    enterEvent(cItems) {
      this.craftImg = "";
      let focusItemIndex = null;
      const selectDom = document.querySelector(
        ".r-peofessional .ivu-select-dropdown-list"
      );
      // 下拉选项有匹配到数据 并且 下拉选项没有隐藏
      if (cItems.CraftsList.length && !selectDom.style.display) {
        // 下拉框中所有选项的Dom
        const items = document.querySelectorAll(
          ".r-peofessional .ivu-select-dropdown-list .ivu-select-item"
        );
        for (let i = 0; i < items.length; i++) {
          let className = items[i].className;
          let hasClass = className.indexOf("ivu-select-item-focus");
          // let hasClass = items[i].classList.has('ivu-select-item-focus')
          if (hasClass >= 0) {
            focusItemIndex = i;
          }
        }

        if (focusItemIndex && focusItemIndex >= 0) {
          this.changeCrafts(cItems.CraftsList[focusItemIndex].ecode);
        } else {
          this.changeCrafts(cItems.CraftsList[0].ecode);
        }

        this.handleFocus();
        let currentItem = this.items.craftList[this.items.craftList.length - 1];
        if (currentItem.sourceType === "TEXT") {
          this.handleCraftContent(currentItem, "TEXT");
        }
      }
    },
    handleCraftClick(item) {
      this.$set(this.items, "craftSelected", item);
    },
    handleEnter(item) {
      this.craftImg = item.craftPath;
    },
    handleLeave() {
      this.craftImg = "";
    },
    handleRemoteFabric(query) {
      this.$emit("handleRemoteFabric", query);
    },
    handleFabricChange(val) {
      this.selectFabric = val
      this.$emit("handleFabricChange", val);
    },
    handleFabricBlur(){
      setTimeout(()=>{
        this.submitData.fabric = this.selectFabric
      },500)
    },
    handleFabricQueryChange(query) {
      this.$emit("handleFabricQueryChange", query);
    },
    handleFabricClear() {
      this.selectFabric = null;
      this.$emit("handleFabricClear");
    },
    handleFabricDel() {
      this.$emit("handleFabricDel");
    },
    handleSource() {
      this.submitData.fabric = '';
      this.selectFabric = null;
      this.$emit("handleFabricStock");
      // this.fabricStock = '';
    },
    handleError() {
      this.craftImg = null;
    },
    handleCraftContent(item, type) {
      this.currentItem = item;
      this.craftContentTitle = item.name;
      this.uploadType = type;
      if (type === "TEXT") {
        if (this.currentItem.content) {
          this.craftContent = this.currentItem.content;
        }
        this.craftContentShow = true;
        if(item.sourceType==='STYLE'){
          this.uploadType = "STYLE";
          this.$nextTick(() => {
            this.$refs.styleText.focus({
              cursor: "type"
            });
          });
        }else{
          this.$nextTick(() => {
            this.$refs.customText.focus({
              cursor: "type"
            });
          });
        }
      } else if (type === "FILE") {
        if (this.currentItem.file) {
          this.craftUpload = {
            file: this.currentItem.file,
            fileName: this.currentItem.fileName,
            href: this.currentItem.href
          };
        }
        this.craftContentShow = true;
      }
    },
    handleCraftContentCancel() {
      this.craftContent = "";
      this.craftUpload = {
        file: null,
        fileName: "",
        href: ""
      };
      this.craftContentShow = false;
      this.uploadType = "";
    },
    handleStyleContentOk(cItems) {
      let styleNo = this.craftContent;
      let focusItemIndex = null;
      const selectDom = document.querySelector(
        ".r-peofessional .ivu-select-dropdown-list"
      );
      // 下拉选项有匹配到数据 并且 下拉选项没有隐藏
      if (cItems.CraftsList.length && !selectDom.style.display) {
        // 下拉框中所有选项的Dom
        const items = document.querySelectorAll(
          ".r-peofessional .ivu-select-dropdown-list .ivu-select-item"
        );
        for (let i = 0; i < items.length; i++) {
          let className = items[i].className;
          let hasClass = className.indexOf("ivu-select-item-focus");
          // let hasClass = items[i].classList.has('ivu-select-item-focus')
          if (hasClass >= 0) {
            focusItemIndex = i;
          }
        }
        styleNo=focusItemIndex && focusItemIndex >= 0?cItems.CraftsList[focusItemIndex].ecode:cItems.CraftsList[0].ecode;
        this.handleFocus();
      }
      this.changeStyleNo(styleNo);
    },
    handleCraftContentOk() {
      if (this.uploadType === "TEXT") {
        this.$set(this.currentItem, "content", this.craftContent);
        this.craftContent = "";
      } else if (this.uploadType === "FILE") {
        this.$set(this.currentItem, "file", this.craftUpload.file);
        this.$set(this.currentItem, "fileName", this.craftUpload.fileName);
        this.$set(this.currentItem, "href", this.craftUpload.href);
        this.craftUpload = {
          file: null,
          fileName: "",
          href: ""
        };
      }
      this.craftContentShow = false;
    },
    // 刺绣字体选择
    handleFontChange(val, embItem) {
      let currentSelected = this.embsFont.children.find(item => {
        return item.id === val;
      });

      if (currentSelected.extension === "file") {
        this.$set(embItem, "uploadContent", true);
        // this.$set(embItem, "embContent", "绣花专用字");
      } else {
        this.$set(embItem, "uploadContent", false);
        this.$set(embItem, "file", null);
        this.$set(embItem, "fileName", "");
        // 如果是绣花专用字就清楚内容
        if (embItem.embContent === "绣花专用字") {
          this.$set(embItem, "embContent", "");
        }
      }
    },
    // 刺绣上传成功
    handleUploadSuccess(response, file, fileList, embItem) {
      if (response.code === 0) {
        this.$set(embItem, "file", response.data.id);
        this.$set(embItem, "fileName", response.data.name);
        this.$set(embItem, "href", response.data.urlPath);
        this.$set(embItem, "embContent", "绣花专用字");
      } else {
        this.$Message.error(response.message);
      }
    },
    // 刺绣上传失败
    handleEmbUploadError(error) {
      this.$Message.error(error.message);
    },
    handleUploadClose(embItem) {
      this.$set(embItem, "file", null);
      this.$set(embItem, "fileName", "");
      this.$set(embItem, "href", "");
    },
    // 工艺上传成功
    handleCraftUploadSuccess(response, file, fileList) {
      if (response.code === 0) {
        this.craftUpload = {
          file: response.data.id,
          fileName: response.data.name,
          href: response.data.urlPath
        };
      }
    },
    handleView() {
      this.craftUploadSrc = this.craftUpload.href;
      this.craftUploadVisible = true;
    },
    handleRemove() {
      this.craftUpload = {
        file: null,
        fileName: "",
        href: ""
      };
    },
    filterMethod(value, option) {
      return option.toUpperCase().indexOf(value.toUpperCase()) !== -1;
    },
    // 回车选中面料
    onFabricEnter() {
      const selectDom = document.querySelector(
        ".faricChoose .ivu-select-dropdown-list"
      );
      // 下拉选项有匹配到数据 并且 下拉选项没有隐藏
      if (this.fabricList.length && !selectDom.style.display) {
        this.submitData.fabric = this.fabricList[0].fabricCode;
        this.$emit("handleEmptyFabricList");
        this.handleFabricChange(this.submitData.fabric);
      }
      // 下拉框中所有选项的Dom
      // const items = document.querySelectorAll(
      //   ".faricChoose .ivu-select-dropdown-list .ivu-select-item"
      // );
      // for (let i = 0; i < items.length; i++) {
      //   let className = items[i].className;
      //   let hasClass = className.indexOf("ivu-select-item-focus");
      //   if (hasClass >= 0) {
      //     focusItemIndex = i;
      //   }
      // }

      // if (focusItemIndex && focusItemIndex >= 0) {
      //   this.handleFabricChange(fabricList[focusItemIndex].fabricCode);
      // }
    }
  },
  mounted() {
    // baseUrl 已经在 data 中设置
    console.log('r-peofessional baseUrl:', this.baseUrl);
    
    this.getEmbInfo(3);
    this.getEmbInfo(2);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
/deep/.ivu-select-selection {
  height: 36px;
  line-height: 36px;
  color: #0a4dcc;
}
.r-peofessional /deep/.ivu-select-dropdown {
  width: 468px !important;
  overflow-x: auto;
}
/deep/.ivu-select-single .ivu-select-selection .ivu-select-placeholder {
  line-height: 36px;
  height: 36px;
}
/deep/.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  line-height: 36px;
  height: 36px;
}
.craftAutocomplete{
  position: sticky;
  top:10px;
  z-index: 9;
  width: 1100px !important;
}
.craftAutocomplete /deep/.ivu-input {
  line-height: 36px;
  height: 36px;
}
.r-peofessional {
  padding: 0 40px;
  margin-bottom: 30px;
  .gy {
    /deep/ .ivu-select-item {
      padding: 0 16px !important;
    }
  }
  .title {
    font-size: 14px;
    font-family: Roboto;
    font-weight: 700;
    text-align: left;
    color: #000000;
    line-height: 16px;
    padding: 10px 0 20px;
  }
  .add-btn {
    width: 36px;
    height: 36px;
    display: block;
    margin-left: 20px;
  }
  .iconqingkong {
    font-size: 18px;
    color: #c9000f;
    margin-left: 20px;
  }
  .crafts-chosoe-item {
    padding: 12px 0px 12px 10px;
    width: 1100px;
    position: relative;
    .iconguanbi {
      font-size: 10px;
      height: 20px;
      line-height: 20px;
      position: absolute;
      right: 10px;
      top: 0;
      bottom: 0;
      margin-top: auto;
      margin-bottom: auto;
      display: inline-block;
    }
    .craftPrice {
      position: absolute;
      right: 40px;
      top: 50%;
      transform: translateY(-50%);
      display: inline-block;
      padding: 4px 8px;
      background-color: #0a4dcc;
      border-radius: 2px;
      font-size: 12px;
      color: white;
    }
  }
  .crafts-item-name {
    font-size: 14px;
    font-family: ArialMT;
    text-align: left;
    color: #081938;
    line-height: 16px;
    margin: 0 5px;
  }
  .crafts-item-content {
    opacity: 0.7;
    font-size: 14px;
    font-family: ArialMT;
    text-align: left;
    color: #081938;
    line-height: 16px;
    max-width: 95%;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    white-space: nowrap; //溢出不换行
  }
  .line {
    width: 2px;
    height: 10px;
    background: #081938;
  }
}
.pHeader {
  padding: 12px 40px 33px;
  background: url(../assets/images/pBg.jpg) no-repeat 0 -5px;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
.craftImg {
  padding: 5px;
  top: 40px;
  left: 480px;
  z-index: 9;
  box-shadow: 0 0 2px 2px #ccc;
}
.craftClickImg {
  width: 180px;
  top: 0;
  right: 0;
  z-index: 9;
}
.fabricSearch {
  width: 283px;
  margin-right: 15px;
  border-radius: 4px;
  padding-right: 7px;
  line-height: 40px;
  border: 1px solid #dcdee2;
  /deep/.ivu-select-selection {
    border: none;
    box-shadow: none;
  }
  /deep/ .ivu-input-icon {
    line-height: 40px;
  }
}
.emb_content /deep/ input {
  height: 36px;
}
/deep/ .embsUploadBtn {
  width: 100%;
  height: 36px;
  line-height: 36px;
}
.embsUploadBtn2 /deep/span {
  display: flex;
  align-items: center;
  justify-content: center;
}
.craftContentTitle {
  width: 250px;
  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //溢出用省略号显示
  white-space: nowrap; //溢出不换行
}
hr {
  margin: 10px 0;
  height: 10px;
  border: none;
  background: #f8f8f8;
}
.cx {
  /deep/ .ivu-select-single .ivu-select-selection {
    height: 36px;
    line-height: 36px;
  }
}
@media screen and (max-height: 1200px) {
  /deep/.ivu-auto-complete.ivu-select-dropdown {
    max-height: 200px !important;
  }
}
.upload-list {
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  margin-right: 4px;
}
.upload-list img {
  width: 100%;
  height: 100%;
}
.upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.upload-list:hover .upload-list-cover {
  display: block;
}
.upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.borderRightLess {
  /deep/.ivu-input {
    border: none;
    height: 40px;
    &:focus {
      box-shadow: none;
    }
  }
}
.cmtInput /deep/ input {
  line-height: 40px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/r-peofessional.vue